<template>
  <div class="panel panel-default">
    <div v-if="showHeader" class="panel-heading">
      <h5 class="pull-left">
        Subscription: {{ subscription.portal.name }}
      </h5>

      <div class="pull-right" style="padding-top: 6px;">
        <status-label :status="subscription.status"></status-label>
      </div>

      <div class="clearfix"></div>
    </div>

    <loading-spinner v-if="loading"></loading-spinner>

    <div v-else class="panel-body">
      <div class="row" style="margin-bottom: 15px;">
        <div class="col-xs-6 text-center" style="border-right: 1px solid #ddd">
                    <span style="font-size: 24px;">
                        <span v-if="!isTrial">
                            {{ startsAt | date }}
                        </span>
                        
                        <span v-else>
                            N/A
                        </span>
                    </span>

          <br>

          <span class="text-muted">
                        Starts At
                    </span>
        </div>

        <div class="col-xs-6 text-center" style="border-right: 1px solid #ddd">
                    <span style="font-size: 24px;">
                        <span v-if="!isTrial">
                           {{ endsAt | date }}
                        </span>
                        
                        <span v-else>
                            N/A
                        </span>
                    </span>

          <br>

          <span class="text-muted">
                        Ends At
                    </span>
        </div>

        <div class="col-xs-6 text-center" style="border-right: 1px solid #ddd">
                    <span style="font-size: 24px;">
                        <span>
                            N/A
                        </span>
                    </span>

          <br>

          <span class="text-muted">
                        Logged In At
                    </span>
        </div>

        <div class="col-xs-6 text-center">
                    <span style="font-size: 24px;">
                        <span>
                            N/A
                        </span>
                    </span>

          <br>

          <span class="text-muted">
                        Accessed At
                    </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import StatusLabel from '@/components/StatusLabel'

export default {
  components: {LoadingSpinner, StatusLabel},

  props: {'subscription': {}, 'showHeader': {'default': true}},

  computed: {
    isTrial() {
      return this.subscription.subscription_periods.length === 0
    },

    startsAt() {
      if (this.isTrial) {
        return null
      }

      return this.subscription.subscription_periods.find(subscriptionPeriod => subscriptionPeriod.is_first).starts_at
    },

    endsAt() {
      if (this.isTrial) {
        return null
      }

      return this.subscription.subscription_periods.find(subscriptionPeriod => subscriptionPeriod.is_last).ends_at
    }
  }
}
</script>
